import { render } from "./MaintenanceHistoryByVehicle.vue?vue&type=template&id=9877cde6"
import script from "./MaintenanceHistoryByVehicle.vue?vue&type=script&lang=js"
export * from "./MaintenanceHistoryByVehicle.vue?vue&type=script&lang=js"
script.render = render

export default script